import { makeStyles } from "@fluentui/react-components";
import { designTokens } from "theme/customTheme";

export const useStyles = makeStyles({
  sidebar: {
    width: "272px",
    flexShrink: 0,
    backgroundColor: designTokens.primary[50],
    borderRight: `1px solid ${designTokens.neutral[200]}`,
    padding: `${designTokens.spacing[5]} ${designTokens.spacing[5]} ${designTokens.spacing[4]}`,
    display: "flex",
    flexDirection: "column",
    overflowY: "auto",
    height: "100%",
    boxSizing: "border-box",
  },

  sidebarInDrawer: {
    borderRight: "none",
    width: "100%",
    height: "auto",
    minHeight: "100%",
  },

  diagnosticName: {
    fontFamily: designTokens.fontFamily,
    fontSize: designTokens.fontSize.lg,
    fontWeight: designTokens.fontWeight.semibold,
    color: designTokens.neutral[900],
    lineHeight: designTokens.lineHeight.tight,
    display: "block",
    marginTop: "0",
    marginBottom: designTokens.spacing[3],
    marginLeft: "0",
    marginRight: "0",
  },

  sectionLabel: {
    display: "block",
    fontFamily: designTokens.fontFamily,
    fontSize: designTokens.fontSize.xs,
    fontWeight: designTokens.fontWeight.semibold,
    color: designTokens.neutral[600],
    textTransform: "uppercase",
    letterSpacing: designTokens.letterSpacing.wide,
    marginTop: "0",
    marginBottom: designTokens.spacing[2],
    marginLeft: "0",
    marginRight: "0",
  },

  progressCount: {
    display: "block",
    fontFamily: designTokens.fontFamily,
    fontSize: designTokens.fontSize.xs,
    fontWeight: designTokens.fontWeight.normal,
    color: designTokens.neutral[600],
    lineHeight: designTokens.lineHeight.normal,
    marginTop: "0",
    marginBottom: designTokens.spacing[2],
    marginLeft: "0",
    marginRight: "0",
  },

  progressWrapper: {
    marginBottom: designTokens.spacing[3],
    "& .fui-ProgressBar": {
      backgroundColor: designTokens.neutral[200],
    },
    "& .fui-ProgressBar__bar": {
      backgroundColor: designTokens.accent[700],
    },
  },

  objectiveList: {
    display: "flex",
    flexDirection: "column",
    gap: designTokens.spacing[1],
    listStyleType: "none",
    marginTop: "0",
    marginBottom: "0",
    paddingLeft: "0",
    paddingRight: "0",
  },

  objectiveItem: {
    display: "flex",
    alignItems: "flex-start",
    gap: designTokens.spacing[2],
    padding: designTokens.spacing[2],
    borderRadius: designTokens.borderRadius.md,
    cursor: "default",
    transition: `background-color ${designTokens.transition.fast}`,
    ":hover": {
      backgroundColor: "var(--obj-hover-bg)",
    },
  },

  objectiveItemActive: {
    backgroundColor: designTokens.accent[50],
    ":hover": {
      backgroundColor: designTokens.accent[50],
    },
  },

  badge: {
    width: "22px",
    height: "22px",
    borderRadius: designTokens.borderRadius.full,
    fontSize: designTokens.fontSize.xxs,
    fontWeight: designTokens.fontWeight.bold,
    flexShrink: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    lineHeight: "1",
  },

  badgeFilled: {
    backgroundColor: designTokens.accent[700],
    color: designTokens.neutral.white,
  },

  badgeUpcoming: {
    backgroundColor: designTokens.neutral[200],
    color: designTokens.neutral[700],
  },

  objectiveTextCol: {
    display: "flex",
    flexDirection: "column",
    gap: designTokens.spacing[1],
    flex: 1,
    minWidth: 0,
  },

  objectiveName: {
    fontFamily: designTokens.fontFamily,
    fontSize: designTokens.fontSize.xs,
    fontWeight: designTokens.fontWeight.medium,
    lineHeight: designTokens.lineHeight.tight,
    color: designTokens.primary[800],
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },

  objectiveNameActive: {
    color: designTokens.neutral[900],
  },

  objectiveNameUpcoming: {
    color: designTokens.neutral[600],
    fontWeight: designTokens.fontWeight.normal,
  },

  statusChip: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    paddingTop: designTokens.spacing[1],
    paddingBottom: designTokens.spacing[1],
    paddingLeft: designTokens.spacing[2],
    paddingRight: designTokens.spacing[2],
    borderRadius: designTokens.borderRadius.md,
    fontSize: designTokens.fontSize.xxs,
    fontWeight: designTokens.fontWeight.semibold,
    fontFamily: designTokens.fontFamily,
    lineHeight: "1",
    alignSelf: "flex-start",
  },

  statusChipCompleted: {
    backgroundColor: designTokens.accent[700],
    color: designTokens.neutral.white,
  },

  statusChipActive: {
    color: designTokens.accent[600],
  },

  statusChipUpcoming: {
    backgroundColor: designTokens.neutral[100],
    color: designTokens.neutral[700],
  },

  footer: {
    marginTop: "auto",
    paddingTop: designTokens.spacing[4],
    borderTop: `1px solid ${designTokens.neutral[200]}`,
    display: "flex",
    flexDirection: "column",
    gap: designTokens.spacing[2],
  },

  footerRow: {
    display: "flex",
    alignItems: "center",
    gap: designTokens.spacing[2],
  },

  footerIcon: {
    flexShrink: 0,
    width: designTokens.iconSize.sm,
    height: designTokens.iconSize.sm,
    color: designTokens.neutral[600],
  },

  footerText: {
    fontFamily: designTokens.fontFamily,
    fontSize: designTokens.fontSize.xs,
    fontWeight: designTokens.fontWeight.normal,
    color: designTokens.neutral[600],
    lineHeight: designTokens.lineHeight.normal,
  },
});
